import { render } from "./LoginScreen.vue?vue&type=template&id=48b01fbe&scoped=true"
import script from "./LoginScreen.vue?vue&type=script&lang=js"
export * from "./LoginScreen.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-48b01fbe"

export default script